import { createSelectorsFromModel } from '@/helpers/redux';

const model = {
    submitting: false,
    serviceId: null,
    message: '',
    error: null,

    details: null,
};

export const selectors = createSelectorsFromModel(
    (state) => state.b2b.share,
    model,
);

export default model;
